import { viewTypes } from '../constants/index.js';

/**
 * Builds the components of a mock file name based on the provided context.
 * This is used to dynamically construct the path to the correct fallback mock file.
 *
 * @param {object} context - The context for building the file name.
 * @param {boolean} context.isMobile - Flag indicating if the view is mobile.
 * @param {boolean} context.isInternational - Flag indicating if the site is international.
 * @param {boolean} context.isDesktopOnly - Flag to force a desktop view type.
 * @param {string} [context.experimentId] - Optional experiment ID to append to the file name.
 * @returns {string} Mock file name (e.g., 'Desktop.domestic.2069-21').
 */
export default function buildMockFileName({ isMobile, isInternational, isDesktopOnly, experimentId }) {
  const deviceType = isDesktopOnly || !isMobile ? viewTypes.desktop : viewTypes.mobile;
  const siteType = isInternational ? 'international' : 'domestic';
  const experiment = experimentId ? `.${experimentId}` : '';

  return `${deviceType}.${siteType}${experiment}`;
}
